import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { FaChevronDown } from "react-icons/fa";
import "./ServiceDetails.css";
const ClinicalAssessment = ({ clinicalAssessment }) => {
  if (!Array.isArray(clinicalAssessment) || clinicalAssessment.length === 0)
    return null;
  return (
    <Accordion allowZeroExpanded>
      <AccordionItem uuid="clinical-assessment">
        <AccordionItemHeading>
          <AccordionItemButton className="bd-header">
            <h4 className="bd-title">Clinical Assessment</h4>
            <span className="bd-add-btn">
              View Details
              <FaChevronDown style={{ marginLeft: "6px" }} />
            </span>
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel className="bd-panel">
          {clinicalAssessment?.map((item, index) => (
            <div
              key={item.id || index}
              className="bd-section-grid bd-grid-3 service-cards"
              style={{ marginBottom: "18px" }}
            >
              <div className="form-group">
                <label className="form-label view-mode-label">
                  Assessment Type
                </label>
                <input
                  disabled
                  className="form-control view-mode-text"
                  value={item.assessment_type_name ?? "—"}
                />
              </div>

              <div className="form-group">
                <label className="form-label view-mode-label">
                  Assessment Mode
                </label>
                <input
                  disabled
                  className="form-control view-mode-text"
                  value={item.assessment_mode_name ?? "—"}
                />
              </div>

              <div className="form-group">
                <label className="form-label view-mode-label">
                  Risk Category
                </label>
                <input
                  disabled
                  className="form-control view-mode-text"
                  value={item.risk_category_name ?? "—"}
                />
              </div>

              <div className="form-group">
                <label className="form-label view-mode-label">
                  Resource Category
                </label>
                <input
                  disabled
                  className="form-control view-mode-text"
                  value={
                    item.resource_category?.length
                      ? item.resource_category.map((r) => r.name).join(", ")
                      : "—"
                  }
                />
              </div>

              <div className="form-group">
                <label className="form-label view-mode-label">
                  Clinical Approved
                </label>
                <input
                  disabled
                  className="form-control view-mode-text"
                  value={item.clinical_approved ? "Yes" : "No"}
                />
              </div>

              <div className="form-group">
                <label className="form-label view-mode-label">
                  Clinical Notes
                </label>
                <textarea
                  disabled
                  rows={3}
                  className="form-control view-mode-text"
                  value={item.clinical_notes || "—"}
                />
              </div>
            </div>
          ))}
        </AccordionItemPanel>
      </AccordionItem>
    </Accordion>
  );
};

export default ClinicalAssessment;
